<template>
  <div class="content-item">
    <h2 class="heading">Pastors Name</h2>
    <p class="text">This will be listed on the card</p>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <input v-model="firstName" type="text" class="form-input" placeholder="First Name" />
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <input v-model="lastName" type="text" class="form-input" placeholder="Last Name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step6',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        pastors_name: `${this.firstName} ${this.lastName}`,
      });
    },
  },
};
</script>

<style lang="scss"></style>
